import { useBrandStore } from "@/stores/brand.js";
import {
  getCurrencyData,
  getFormattedAmountOnCurrency,
} from "country-currency-utils";

export const currencySymbol = (currencyCode) => {
  const currency = getCurrencyData(currencyCode);

  return currency?.symbolPreferred || "$";
};

/**
 *
 * @param {number} amount
 * @param {boolean} showCurrSym
 * @param {string|null} currencyCode E.g. 'USD', 'GBP', 'INR'
 * @param {boolean} showDecimalsOnWholeNumber Whether to show decimals for whole numbers
 * @param {boolean} useCurrencyCodeAsSymbol Whether to use the currency code as the symbol (e.g. USD 1,000 instead of $1,000)
 * @example
 * formatCurrency(1000), true, 'USD', false) // $1,000
 * formatCurrency(1000), true, 'USD', true)  // $1,000.00
 * formatCurrency(1000), true, 'USD', false, true) // USD 1,000
 * formatCurrency(1000), true, 'USD', true, true)  // USD 1,000.00
 * formatCurrency(1000), false, 'USD', false) // 1,000
 * @returns
 */
export function currencyConvertWCountry(
  amount,
  showCurrSym = true,
  currencyCode = null,
  showDecimalsOnWholeNumber = false,
  useCurrencyCodeAsSymbol = false
) {
  const { currCode } = useBrandStore();
  const currency = getCurrencyData(currencyCode ? currencyCode : currCode);

  if (!amount || isNaN(Number(amount))) {
    const zero = showDecimalsOnWholeNumber ? "0.00" : "0";
    const symbol = useCurrencyCodeAsSymbol
      ? `${currency.currencyCode} `
      : currency.symbolPreferred;
    return showCurrSym ? `${symbol}${zero}` : zero;
  }

  const formattedAmount = getFormattedAmountOnCurrency(
    Number(amount),
    currency,
    {
      roundingMethod: "round",
      roundingDecimals: "compact",
      separator: ",",
    }
  );

  const cleanedAmount = !showDecimalsOnWholeNumber
    ? formattedAmount.replace(/\.00$/, "")
    : formattedAmount;

  if (showCurrSym && useCurrencyCodeAsSymbol) {
    return `${currency.currencyCode} ${cleanedAmount}`;
  }

  return showCurrSym
    ? `${currency.symbolPreferred}${cleanedAmount}`
    : cleanedAmount;
}

export function formatCurrency(
  amount,
  showSymbol = true,
  showDecimalsOnWholeNumber = false
) {
  const store = useBrandStore();
  return currencyConvertWCountry(
    parseFloat(String(amount).replace(/,/g, "")),
    showSymbol,
    store.currCode,
    showDecimalsOnWholeNumber
  );
}

export function formatBillingCurrency(
  amount,
  showSymbol = true,
  showDecimalsOnWholeNumber = false
) {
  const store = useBrandStore();
  return currencyConvertWCountry(
    parseFloat(String(amount).replace(/,/g, "")),
    showSymbol,
    store.billingCurrCode,
    showDecimalsOnWholeNumber,
    true
  );
}

export function wholeNumber(number) {
  return Number(number).toLocaleString("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    useGrouping: true,
  });
}
